 const headers = document.querySelectorAll('.accordion-header');

    headers.forEach(header => {
      header.addEventListener('click', () => {
        // Close other accordions
        headers.forEach(item => {
          if (item !== header) {
            item.classList.remove('active');
            item.querySelector('span').textContent = '▲';
            item.nextElementSibling.style.display = 'none';
          }
        });

        // Toggle current accordion
        const content = header.nextElementSibling;
        if (header.classList.contains('active')) {
          header.classList.remove('active');
          header.querySelector('span').textContent = '▲';
          content.style.display = 'none';
        } else {
          header.classList.add('active');
          header.querySelector('span').textContent = '▲';
          content.style.display = 'block';
        }
      });
    });